// @ts-ignore: recursive structure
export type ParseableClassNameValue = string
  | ParseableClassNameValue[]
  | { toString: () => string }
  | Record<string, ParseableClassNameValue>
;

export default function classnames(...args: ParseableClassNameValue[]): string {
  return appendClasses(args.map(arg => arg ? parseValue(arg) : undefined));
}

function parseValue(arg: ParseableClassNameValue): string {
  if (typeof arg === 'string') {
    return arg;
  }

  if (typeof arg !== 'object') {
    return '';
  }

  if (Array.isArray(arg)) {
    return classnames.apply(null, arg);
  }

  if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
    return arg.toString();
  }

  const classes = appendClasses(Object.entries(arg).map(
    ([key, value]) => value ? key : undefined
  ));

  return classes;
}

function appendClasses(classes: (string | null | undefined)[]): string {
  const array: string[] = [];

  classes.forEach(cls => {
    if (Array.isArray(cls)) {
      cls.forEach(cls2 => {
        if (cls2) {
          array.push(cls2);
        }
      });
    } else if (cls) {
      array.push(cls);
    }
  })

  return array.join(" ");
}
